import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Input from '../../form/Input'
import Button from '../../../UniformComponents/Button'

const SectionTitleModal = ({ store }) => (
    <Modal
        show={store.sectionTitleModalVisible}
        onClose={store.handleCloseSectionTitleModal}
    >
        <Typography type="h2">Section settings</Typography>

        <br />

        <hr />

        <br />

        <Input
            label="Section title"
            onBlur={store.editSectionTitle}
            defaultValue={store.sectionTitleForEdit}
        />

        <br />

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                icon="far fa-save"
                label="Save"
                onClick={store.handleCloseSectionTitleModal}
                cssClass="regular primary"
            />
        </div>
    </Modal>
)

export default observer(SectionTitleModal)
